<template>
  <div class="d-flex h-100 w-100 justify-content-center login-container">
    <div class="align-self-center">
      <div class="card reset-panel">
        <div class="card-header">Reset password
        </div>
        <div class="card-body">
          <b-form-group
            label="Password" label-for="password">
            <b-form-input type="password" ref="passwordInput" id="password"
                          v-model="password" required
                          placeholder="Enter password"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Password repeat" label-for="passrep">
            <b-form-input type="password" ref="passrepInput" id="passrep"
                          v-model="passrep" required
                          placeholder="Repeat password"
            ></b-form-input>
          </b-form-group>
        </div>
        <div slot="footer">
          <div class="reset-footer">
            <b-btn-group class="btn-block">
              <b-button class="btn-sm" :disabled="loading" @click="cancel">Cancel
              </b-button>
              <b-button class="btn-sm" :disabled="loading || !password || (password !== passrep)"
                        @click.stop.prevent="onSubmit" type="submit">
                Submit
              </b-button>
          </b-btn-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'reset-password',
    data () {
      return {
        passrep: '',
        password: '',
        loading: false
      }
    },
    methods: {
      onSubmit () {
        let formData = new FormData()
        formData.append('password', this.password)
        formData.append('token', this.$route.query['token'])
        formData.append('username', this.$route.query['username'])
        this.loading = true
        this.$http.post('/api/password-reset', formData)
          .then(res => {
            this.$notify({
              title: 'SUCCESS',
              text: 'Password successfully reset.',
              type: 'success'
            })
            this.loading = false
            location.href = '/'
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not reset password.',
              type: 'error'
            })
            this.loading = false
          })
      },
      cancel () {
        location.href = '/'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/ResetPassword.vue